import { Components, Theme } from '@mui/material';

export const MuiContainerStyle: Components<Theme>['MuiContainer'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      [theme.breakpoints.up('xs')]: {
        maxWidth: '100%',
        padding: '0 1.5rem',
      },
      [theme.breakpoints.up('md')]: {
        padding: '0 3rem',
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: '896px',
        padding: '0',
      },
      [theme.breakpoints.up('xl')]: {
        maxWidth: '1120px',
      },
      margin: '0 !important',
    }),
  },
};
